import React from 'react';
import { Divider, IconButton, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useTranslation } from 'react-i18next';
import LogoByAds from '../../assets/faz.png';
import ShareIcon from '@mui/icons-material/Share';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from 'react-router-dom';
import { styled } from "@mui/material/styles";
import { keyframes } from "@emotion/react";

const PREFIX = 'BackdropCardInfo';

const classes = {
  alignItems: `${PREFIX}-alignItems`,
  root: `${PREFIX}-root`,
  leftContainer: `${PREFIX}-leftContainer`,
  rightContainer: `${PREFIX}-rightContainer`,
  logoStyle: `${PREFIX}-logoStyle`,
  divider: `${PREFIX}-divider`,
  title: `${PREFIX}-title`,
  joinExparienceText: `${PREFIX}-joinExparienceText`,
  descriptionApp: `${PREFIX}-descriptionApp`,
  bottomIconsContainer: `${PREFIX}-bottomIconsContainer`,
  iconsRow: `${PREFIX}-iconsRow`,
  shareIconButton: `${PREFIX}-shareIconButton`,
  settingsIconButton: `${PREFIX}-settingsIconButton`,
  playIconButton: `${PREFIX}-playIconButton`,
  topCircle: `${PREFIX}-topCircle`,
};

const myEffect = keyframes`
  "0%": {
    opacity: 0,
  },
  "80%": {
    opacity: 0,
  },
  "100%": {
    opacity: 1,
  }
`;

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.alignItems}`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '560px',
    backgroundColor: "#282828",
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
  },

  [`& .${classes.root}`]: {
    display: 'flex',
    width: '100%'
  },

  [`& .${classes.leftContainer}`]: {
    padding: '16px 0 16px 16px',
    width: '32%',
    maxWidth: '200px',
    marginRight: '2rem',
    display: 'flex',
    justifyContent: 'center'
  },

  [`& .${classes.rightContainer}`]: {
    padding: '16px 16px 0 0',
    width: 'calc(68% - 2rem)',
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.logoStyle}`]: {
    maxWidth: '130px',
    maxHeight: '130px',
    objectFit: 'contain',
    borderRadius: '10px',
  },

  [`& .${classes.divider}`]: {
    height: '2px',
    width: '100%',
    marginBottom: '10px',
  },

  [`& .${classes.title}`]: {
    fontSize: '16px',
    marginBottom: '1rem',
    color: '#a0a0a0',
    fontWeight: '600'
  },

  [`& .${classes.joinExparienceText}`]: {
    marginBottom: '1rem',
    color: 'white',
    // fontSize: '14px',
    lineHeight: 'normal',
  },

  [`& .${classes.descriptionApp}`]: {
    color: 'white',
    height: '100px',
    overflowY: 'auto',
    fontSize: '14px',
    lineHeight: 'normal',
  },

  [`& .${classes.bottomIconsContainer}`]: {
    display: 'flex',
    flexDirection: 'column',
    padding: '5px'
  },

  [`& .${classes.iconsRow}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  [`& .${classes.shareIconButton}`]: {
    color: "#343434",
    backgroundColor: theme.palette.primary.main,
    width: '45px',
    height: '45px',
    marginRight: '0.5rem',
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: "#343434",
    }
  },

  [`& .${classes.settingsIconButton}`]: {
    color: "#343434",
    backgroundColor: theme.palette.primary.main,
    width: '45px',
    height: '45px',
    marginRight: '0.5rem',
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: "#343434",
    }
  },

  [`& .${classes.playIconButton}`]: {
    color: "#343434",
    backgroundColor: theme.palette.primary.main,
    width: '45px',
    height: '45px',
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: "#343434",
    }
  },

  [`& .${classes.topCircle}`]: {
    position: "absolute",
    left: "50%",
    top: "-5px",
    width: "10px",
    height: "10px",
    backgroundColor: "rgb(211, 175, 95)",
    transform: "translate(-5px, 0)",
    borderRadius: "20px",
    animation: `${myEffect} 1000ms ${theme.transitions.easing.easeInOut}`
  },
}))

const BackdropCardInfo = (props) => {
  const { t } = useTranslation();
  const history = useNavigate();

  const shareMedia = () => {
    navigator.share({
      title: document.title,
      text: `${t('myDesign.webVR.shareExparienceStart')}${props.element.exparience.displayName || props.element.exparience.name}${t('myDesign.webVR.shareExparienceEnd')}`,
      url: props.element.exparience.arLink
    })
  }

  if (props.element) {
    return (
      <Root>
        <div className={classes.alignItems}>
          <div className={classes.root}>
            <div className={classes.leftContainer}>
              <img
                className={classes.logoStyle}
                src={props.element.exparience?.logoUrl || props.element?.logo || LogoByAds}
                alt={`logo url ${props.element.exparience.displayName}`}
              />
            </div>
            <div className={classes.topCircle} />
            <div className={classes.rightContainer}>
              <div className={classes.title}>
                {props.element.exparience.displayName}
              </div>
              <Typography variant="body2" className={classes.joinExparienceText}>
                {t('homePage.joinExparienceText')}
                {props.element.exparience.displayName}!
              </Typography>
              {props.element.exparience.descriptionApp ?
                <div className={classes.descriptionApp} dangerouslySetInnerHTML={{ __html: props.element.exparience.descriptionApp }} />
                :
                <div className={classes.descriptionApp}>{t('homePage.defaultDescription')}</div>
              }
            </div>
          </div>
          <div className={classes.bottomIconsContainer}>
            <Divider light className={classes.divider} />
            <div className={classes.iconsRow}>
              <IconButton
                className={classes.settingsIconButton}
                onClick={() => history(`/myExpariences/${props.element.exparienceId}`)}
                size="large">
                <SettingsIcon />
              </IconButton>
              {props.element.exparience?.arLink &&
                <IconButton
                  className={classes.shareIconButton}
                  onClick={() => shareMedia()}
                  size="large">
                  <ShareIcon />
                </IconButton>
              }
              <IconButton
                className={classes.playIconButton}
                onClick={() => window.location.assign(props.element.exparience.arLink || 'https://app.fanartzone.com')}
                size="large">
                <PlayArrowIcon />
              </IconButton>
            </div>
          </div>
        </div>
      </Root>
    );
  } else {
    return null;
  }
}

export default BackdropCardInfo;
